import { BrowserRouter, Routes, Route } from "react-router-dom";
import AuthRoute from "./components/Auth/Routes/AuthRoute";
import RecruitmentRoutes from "./components/Employee/Recruitment/RecruitmentLayout/Routes/RecruitmentRoutes";
import ProtectedRoute from "./components/Employee/Recruitment/ProtectedRoutes/ProtectedRoute";
import InactiveUser from "../src/components/Common/AccessControl/InactiveUser";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuthRoute />} />
        <Route path="/inactive-user" element={<InactiveUser />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <RecruitmentRoutes />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
